import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NSAutocompleteModule } from '@norfolk-southern/accessns-components';

import { CommercialSummaryRoutingModule } from '@ruby/modules/short-line-profile/submodules/commercial-summary/commercial-summary-routing.module';
import { CommercialSummaryComponent } from '@ruby/modules/short-line-profile/submodules/commercial-summary/components/commercial-summary.component';
import { CommercialSummaryContainer } from '@ruby/modules/short-line-profile/submodules/commercial-summary/containers/commercial-summary.container';
import { DirectivesModule } from '@ruby/shared/directives/directives.module';

@NgModule({
  declarations: [CommercialSummaryContainer, CommercialSummaryComponent],
  imports: [
    CommonModule,
    CommercialSummaryRoutingModule,
    DirectivesModule,
    MatButtonModule,
    MatDividerModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressBarModule,
    NSAutocompleteModule,
    ReactiveFormsModule,
    MatTooltipModule
  ],
  exports: [CommercialSummaryContainer]
})
export class CommercialSummaryModule {}
